import { all, call } from 'redux-saga/effects';

import { listingsSagas } from './listings/sagas';
import { dealerProfileSettingsSagas } from './account/DealerProfileSettings/sagas';

export function* dealerPortalSagas() {
  yield all([call(listingsSagas), call(dealerProfileSettingsSagas)]);
}
